import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_DIRECT_PLACEMENT_PAYMENTS } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const directPlacementsPayments = {
  namespaced: true,
  state: buildInitialState({
    directPlacementPaymentList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setDirectPlacementsPayments: (state, directPlacements) => {
      state.directPlacementPaymentList = directPlacements
    }
  },
  actions: {
    getDirectPlacementsPayments: ({ commit }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DIRECT_PLACEMENT_PAYMENTS, parameters: filters })
        .then(json => json.data)
        .then(directPlacementsPayments => {
          commit('updateStatus', { status: COMPLETE })
          commit('setDirectPlacementsPayments', directPlacementsPayments)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default directPlacementsPayments
